/**
 * Lux Hero
 * - Video fades in only once actually playing (image stays as instant frame).
 * - Plays/pauses with viewport visibility (battery + bandwidth).
 * - Never autoplays for prefers-reduced-motion users.
 * - Honors the "no video on mobile" setting.
 * - Scroll indicator smooth-scrolls to the next section.
 */
(function () {
  'use strict';

  if (customElements.get('lux-hero')) return;

  class LuxHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.lux-hero__video');
      this.setupScrollButton();

      if (!this.video) return;

      var reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;
      var mobileBlocked =
        this.dataset.videoMobile === 'false' &&
        window.matchMedia('(max-width: 749px)').matches;

      if (reducedMotion || mobileBlocked) {
        this.video.removeAttribute('autoplay');
        this.video.pause();
        return; // image remains the hero media
      }

      this.video.addEventListener('playing', () => {
        this.video.classList.add('is-playing');
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                var playAttempt = this.video.play();
                if (playAttempt && playAttempt.catch) {
                  playAttempt.catch(function () {
                    /* Autoplay blocked by browser — image stays. */
                  });
                }
              } else {
                this.video.pause();
              }
            });
          },
          { threshold: 0.1 }
        );
        this.observer.observe(this);
      } else {
        this.video.play().catch(function () {});
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    setupScrollButton() {
      var btn = this.querySelector('[data-hero-scroll]');
      if (!btn) return;

      btn.addEventListener('click', () => {
        var section = this.closest('.shopify-section');
        var next = section && section.nextElementSibling;
        if (next) {
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  customElements.define('lux-hero', LuxHero);
})();